// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"459df19a","703":"b53d7282"}[chunkId] + ".chunk.js";
};